"use client";

import Image from "next/image";
import Container from "@/components/ui/Container";

export default function FinalCTA() {
  return (
    <section
      className="text-white"
      style={{
        padding: "60px 0 30px 0",
        background:
          "linear-gradient(0deg, rgba(52, 78, 65, 0.85) 0%, rgba(52, 78, 65, 0.85) 100%), url('/images/Bloom-Wise_footer_background.webp') lightgray 50% / cover no-repeat",
      }}
    >
      <Container>
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Column - Title */}
          <div>
            <h2
              className="text-center lg:text-left text-[32px] lg:text-[40px] leading-[40px] lg:leading-[50px]"
              style={{
                alignSelf: "stretch",
                color: "#FFF",
                fontWeight: 400,
              }}
            >
              ¿Estás listo para vivir la experiencia Bloom Wise?
            </h2>
          </div>

          {/* Right Column - App Store Badges */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-end items-center">
            <a href="#" className="hover:opacity-80 transition-opacity">
              <Image
                src="/images/google_play_button.svg"
                alt="Disponible en Google Play"
                width={250}
                height={69}
              />
            </a>
            <a href="#" className="hover:opacity-80 transition-opacity">
              <Image
                src="/images/apple_store_button.svg"
                alt="Disponible en App Store"
                width={250}
                height={69}
              />
            </a>
          </div>
        </div>
      </Container>
    </section>
  );
}
